<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="introduction">
<h2 class="h2" id="fmlev2"><span epub:type="pagebreak" id="page_6"><img alt="Image" class="in100" src="images/line.jpg"/><br/>DRAWING TOOLS &amp; MATERIALS<br/><img alt="Image" class="in100" src="images/line.jpg"/></span></h2>
<p class="intro">These are some of the drawing tools I use every day. You’ll notice a variety of pens, pencils, and erasers. I feel that the greater the variety of utensils you have for mark-making, the better and more flexible your work will be! Of course, you don’t need all of these tools to make great art. All you really need are a few trusty supplies.</p>
<div class="land90"><img alt="Image" id="f0006-01.jpg" src="images/f0006-01.jpg"/></div>
<div class="group">
<p class="ahead"><span epub:type="pagebreak" id="page_7"><strong>1. Ballpoint Pen</strong></span></p>
<p class="noindentb">I like to use a BIC<sup>®</sup> ballpoint. This pen is great for loose sketching, doodling, and taking along for travel. It creates a light, single-weight line and can be used with different pressure to achieve some subtle shading effects.</p>
</div>
<div class="group">
<p class="ahead"><strong>2. Tombow</strong><sup>®</sup> <strong>MONO Drawing Pen, Size 03</strong></p>
<p class="noindentb">This is my favorite inking pen—I use it in almost all of my final illustrations. This is a felt-tip pen with a small nib. It delivers a single-weight line (hence the name, “MONO”) that is rich with ink and won’t scrub up when you erase lines underneath. The MONO pens come in three sizes: 01 (very fine), 03 (fine), and 05 (medium).</p>
</div>
<div class="group">
<p class="ahead"><strong>3. Tombow Fudenosuke Calligraphy Pen, Soft Tip</strong></p>
<p class="noindentb">I love this pen for lettering! For reference, the lettering section of this book was done almost exclusively with this calligraphy pen. This pen has a sturdy brush tip, but the bristles stay together for a bouncy tip that allows for great variation in line weight. It’s also available with a hard tip.</p>
</div>
<div class="group">
<p class="ahead"><strong>4. Pentel</strong><sup>®</sup> <strong>Brush Pen</strong></p>
<p class="noindentb">This pen has a bristly, thick tip that is great for lettering and making inkier, sweeping marks. Every brushstroke has natural edges, creating a beautiful, organic feel.</p>
</div>
<div class="group">
<p class="ahead"><strong>5. Tombow Dual Brush Pen</strong></p>
<p class="noindentb">This pen is perfect for both traveling and as a mainstay in your drawing kit. One side uncaps to reveal a flexible brush tip that allows for great line variation, while the other side uncaps a fine tip that is ideal for detailing and fixing little inconsistencies. I love this pen for its versatility.</p>
</div>
<div class="group">
<p class="ahead"><strong>6. 4H Pencil</strong></p>
<p class="noindentb">In the next section, we will discuss basic drawing techniques and how to achieve them with different tools. This pencil is at the hard end of the HB graphite spectrum. It creates a very lightweight, precise line.</p>
</div>
<div class="group">
<p class="ahead"><strong>7. HB Pencil</strong></p>
<p class="noindentb">This pencil is in the middle of the HB graphite spectrum; it has some give and thickness. It’s great for shading!</p>
</div>
<div class="group">
<p class="ahead"><strong>8. 6B Pencil</strong></p>
<p class="noindentb">This pencil is at the soft end of the HB graphite spectrum. It’s very easy to use and provides a very dark mark with little pressure.</p>
</div>
<div class="group">
<p class="ahead"><strong>9. Pentel Mechanical Pencil</strong></p>
<p class="noindentb">Sometimes for loose sketching or sketches that will be inked, I use a simple mechanical pencil. They are easy to use and easy to erase—and they pack perfectly with the built-in eraser.</p>
</div>
<div class="group">
<p class="ahead"><strong>10. Standard Sharpener</strong></p>
<p class="noindentb">I like a basic sharpener for my pencils, but if you’re on the go frequently or are in school, you can use one that has a plastic cover for catching shavings.</p>
</div>
<div class="group">
<p class="ahead"><strong>11. Tombow MONO Eraser</strong></p>
<p class="noindentb">This is a great, large plastic eraser that works well on light sketches.</p>
</div>
<div class="group">
<p class="ahead"><strong>12. Tombow MONO Knock Eraser</strong></p>
<p class="noindentb">I love this eraser. It comes in pen form with a clicking bottom that pushes up the eraser like the lead of a mechanical pencil. It has a small, soft tip that is ideal for erasing small areas. And the lead pickup is great!</p>
</div>
<div class="group">
<p class="ahead"><strong>13. Tombow MONO Zero Eraser</strong></p>
<p class="noindentb">If you love putting detail into your sketches, this is the perfect eraser for you. It has a tiny but flexible tip, allowing you to erase the smallest of areas cleanly.</p>
</div>
<div class="group">
<p class="ahead"><strong>14. Tombow MONO Dust Catch Eraser</strong></p>
<p class="noindentb">This eraser is excellent for traveling! It’s a black plastic eraser that clings to itself. It erases naturally, but instead of creating little “pills” of eraser material, it rolls together to drastically reduce the amount of eraser dust left on the page.</p>
</div>
<div class="group">
<p class="ahead"><strong>15. Ruler</strong></p>
<p class="noindentb">I always like to keep a ruler handy. You never know when you’ll need it. In this book, there are several sections that require a ruler or straightedge!</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?d4f6622c